/* global isMobileBrowser */

(function () {
	$('.nav-toggle').on('click', function (e) {
		const expand = !$('.nav-icon').hasClass('open');
		$('.nav-icon').toggleClass('open', expand);
		$('#nav').toggleClass('expanded', expand);
		e.preventDefault();
	});

	/** @type {HTMLDivElement} */
	const offcanvasSideMenue = document.getElementById('offcanvas-side-menue');

	if (offcanvasSideMenue) {
		/** @type {HTMLButtonElement} */
		const einblendenButton = document.querySelector('#offcanvas-side-menue + .mobile-sidebar-button');
		/** @type {HTMLButtonElement} */
		const ausblendenButton = document.querySelector('#offcanvas-side-menue .mobile-sidebar-button');
		offcanvasSideMenue.addEventListener('hidden.bs.offcanvas', () => {
			einblendenButton.focus();
		});
		offcanvasSideMenue.addEventListener('shown.bs.offcanvas', () => {
			(offcanvasSideMenue.querySelector('input.is-invalid') ?? ausblendenButton).focus();
		});
		if (isMobileBrowser()) {
			$('.sidebar, .mobile-sidebar-button').swipe({
				swipeRight: () => {
					if ($(window).innerWidth() < 768) {
						window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasSideMenue).show();
					}
				},
				swipeLeft: () => {
					if ($(window).innerWidth() < 768) {
						window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasSideMenue).hide();
					}
				},
			});
		}
	}

	$('#epaper-download :input').on('change', function () {
		$('[data-publication][data-town]').addClass('hidden');
		$(`[data-publication="${$('input[name="publication"]:checked').val()}"][data-town="${$('select[name="town"]').val()}"]`).removeClass('hidden');
	});
})();
